import { FC, useEffect, useState } from 'react';
import { GetDepositsService } from '../../api/get-deposits-service';
import { TDeposit } from '../../../../shared/api/contract';
import styles from './Deposits.module.scss';

import Loader from '../../../../shared/ui/Loader/Loader';

import { ConnectorType, useAppKitProvider } from '@reown/appkit/react';
import { contractABI } from '../../../../shared/api/contract/config';
import { useAccount } from 'wagmi';
import Deposit from '../Deposit/Deposit';
import { useTranslation } from 'react-i18next';

const Deposits: FC<{ setFetching: () => void }> = ({ setFetching }) => {
    const [deposits, setDeposits] = useState<TDeposit[]>([]);
    const [depositsIndexes, setDepositsIndexes] = useState<bigint[]>([]);
    const { address } = useAccount();

    const { walletProvider } = useAppKitProvider<ConnectorType>('eip155');
    const [loading, setLoading] = useState<boolean>(true);

    const { t } = useTranslation();

    const depositService = address ? new GetDepositsService(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address) : undefined;
    useEffect(() => {


        if (!address || !loading) return;

        async function main() {
            try {
                if (!address || !depositService) return;
                const [deposits, depositsIndexes] = await depositService.getDeposits(address);
                console.log(deposits);
                setDeposits(deposits);
                setDepositsIndexes(depositsIndexes);
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }

        main();
    }, [address, loading]);

    return (
        <div className={styles.deposit}>
            {!loading && deposits.length === 0 && (
                <div className={styles.none}>
                    <p>{t('none_deposits')}</p>
                </div>
            )}

            {!loading &&
                deposits.map((deposit, i) => (
                    <Deposit
                        key={deposit.lockEnds + Math.random() * 34}
                        {...deposit}
                        index={depositsIndexes[i]}
                        reload={() => {
                            setLoading(true);
                        }}
                    />
                ))}

            {loading && <Loader />}
        </div>
    );
};

export default Deposits;
